import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import {  ScopoProvvedimento } from '../models';


class DataTablesResponse {
    data: ScopoProvvedimento[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class ScopoProvvedimentoService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}ScopiProvvedimento/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<ScopoProvvedimento[]>(
            `${this.apiUrl}`
        );
    }
    insert(s: ScopoProvvedimento) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: ScopoProvvedimento) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:ScopoProvvedimento){
        if (s.id) return this.update(s);
        return this.insert(s);
    }

}
